import { apiRequest, apiRequestNoAuth } from "./util";

export async function handleZapier(method, data) {
  try {
      const response = await apiRequest('zapier', "POST", {
        action: method,
        data: data
      });
      return(response)
  } catch (error) {
      console.error('Error:', error);
      throw error
  }
}

// Public actions only (createLead): fired by the ebook lead forms before an
// account exists, so no Firebase token is attached.
export async function handleZapierPublic(method, data) {
  try {
      const response = await apiRequestNoAuth('zapier', "POST", {
        action: method,
        data: data
      });
      return(response)
  } catch (error) {
      console.error('Error:', error);
      throw error
  }
}

// Server-side callers only (api/stripe-webhook.js, api/stripe-create-checkout-session.js).
// There is no user session on the server, so the call is authenticated with the
// shared INTERNAL_API_SECRET. That variable is never REACT_APP_-prefixed, so it
// is undefined in the browser bundle and this function is unusable there.
export async function handleZapierExternal(method, data) {
  try {
      const response = await fetch('https://insuranceagencytraining.org/api/zapier', {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "x-internal-secret": process.env.INTERNAL_API_SECRET || "",
        },
        body: JSON.stringify({ action: method, data: data }),
      }).then((response) => response.json());
      return(response)
  } catch (error) {
      console.error('Error:', error);
      throw error
  }
}